import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { StaticPageMixin } from '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

/**
 * Component displaying static page content only.
 * Useful when using static page as nested content (e.g. nested T&C)
 */
var StaticPageContentComponent = /** @class */ (function (_super) {
    __extends(StaticPageContentComponent, _super);
    function StaticPageContentComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StaticPageContentComponent.prototype, "topNav", {
        get: function () {
            return this.variant === 'top-nav';
        },
        enumerable: false,
        configurable: true
    });
    StaticPageContentComponent.prototype.scrollToHash = function () {
        if (window.location.hash && this.content && this.$refs.text) {
            var elem = this.$refs.text.shadowRoot.querySelector(window.location.hash);
            if (elem) {
                elem.scrollIntoView();
            }
        }
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageContentComponent.prototype, "variant", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", Boolean)
    ], StaticPageContentComponent.prototype, "headless", void 0);
    StaticPageContentComponent = __decorate([
        Component({
            name: 'static-page-content',
        })
    ], StaticPageContentComponent);
    return StaticPageContentComponent;
}(Mixins(StaticPageMixin)));

export default StaticPageContentComponent;
